export async function progressPromise<T, T2>(
  executor: (
    resolve: (value: PromiseLike<T> | T) => void,
    reject: (reason?: Error) => void,
    progressor: (progress: T2) => void,
  ) => void,
  progressor: (progress: T2) => void,
): Promise<T> {
  return await new Promise<T>((res, rej) => {
    executor(res, rej, progressor);
  });
}
